import { useMemo } from 'react'

import { useOperativeTokenCatalog } from '@/features/tokens/useOperativeTokenCatalog'
import { useUserAddedTokens } from '@/state/user/hooks'

import { ChainId, Currency } from '../../sdk'

import { buildVisibleCatalogCurrencies } from './swapCatalog'

/** Tokens visibles para UI: catálogo operativo + tokens importados (sin wrapped native). */
export function useSwapCatalogTokens(chainId: ChainId): Currency[] {
  const { entries } = useOperativeTokenCatalog()
  const userAddedTokens = useUserAddedTokens()

  return useMemo(
    () => buildVisibleCatalogCurrencies(chainId, entries, userAddedTokens),
    [chainId, entries, userAddedTokens],
  )
}
